var Spinner = require('spin.js');
var module = angular.module('octopusApp.infrastructure');

module.directive('inlineSpin', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      active: '=active'
    },
    template: '<span></span>',
    link: function (scope, element) {
      var opts = {
        lines: 12,                  // The number of lines to draw
        length: 2,                  // The length of each line
        width: 3,                   // The line thickness
        radius: 6,                 // The radius of the inner circle
        corners: 1,                 // Corner roundness (0..1)
        rotate: 0,                  // The rotation offset
        direction: -1,              // 1: clockwise, -1: counterclockwise
        color: '#889',              // #rgb or #rrggbb
        speed: 1,                   // Rounds per second
        trail: 60,                  // Afterglow percentage
        shadow: false,              // Whether to render a shadow
        hwaccel: false,             // Whether to use hardware acceleration
        className: 'spinner-inline',       // The CSS class to assign to the spinner
        zIndex: 2e9,                // The z-index (defaults to 2000000000)
        top: '0',                   // Top position relative to parent in px
        left: '0'                   // Left position relative to parent in px
      };

      var spinJsSpinner = new Spinner(opts);

      var container = element;

      var spinning = false;
      var update = function () {
        if (scope.active && !spinning) {
          spinning = true;
          spinJsSpinner.spin(container[0]);
        } else if (!scope.active && spinning) {
          spinning = false;
          spinJsSpinner.stop(container[0]);
        }
      };

      scope.$watch('active', function () {
        update();
      });

      update();
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/inline_spin.js
// module id = 664
// module chunks = 1